import { render, staticRenderFns } from "./PostpondProgramComponent.vue?vue&type=template&id=5dd23575&"
import script from "./PostpondProgramComponent.vue?vue&type=script&lang=js&"
export * from "./PostpondProgramComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports